/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dateRangeSchema } from './dateRangeSchema';

export const progressTrendsRequestSchema = z.object({
  get dateRange() {
    return z.union([dateRangeSchema, z.null()]).optional();
  },
  filter: z.string().nullish(),
  targetDateOverride: z.iso.date().nullish(),
  today: z.iso.date().nullish(),
});
